import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';

/**
 * EmptySearchState Component
 * 
 * Displays a message when no search results are found.
 * Provides a clear action to reset the search.
 * 
 * @param {Object} props
 * @param {string} props.searchQuery - The current search query
 * @param {function} props.onClearSearch - Callback to clear the search
 * @param {Object} props.themeStyles - Theme-specific styling object (optional)
 */
const EmptySearchState = ({
  searchQuery,
  onClearSearch,
  themeStyles = {},
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 3,
        textAlign: 'center',
      }}
    >
      <SearchOffIcon
        sx={{
          fontSize: 80,
          opacity: 0.3,
          mb: 2,
          ...themeStyles.cardTitle,
        }}
      />
      <Typography
        variant="h6"
        sx={{
          mb: 1,
          fontWeight: 600,
          ...themeStyles.cardTitle,
        }}
      >
        No results found
      </Typography>
      <Typography
        variant="body2"
        sx={{
          mb: 3,
          opacity: 0.7,
          maxWidth: 400,
          ...themeStyles.cardDescription,
        }}
      >
        We couldn't find any navigation items matching "{searchQuery}". 
        Try adjusting your search or clear it to see all options.
      </Typography>
      <Button
        variant="outlined"
        onClick={onClearSearch}
        sx={{
          textTransform: 'none',
          borderRadius: 2,
          px: 3,
          ...themeStyles.card,
          border: '1px solid',
          borderColor: themeStyles.card?.borderColor || 'rgba(0, 0, 0, 0.23)',
          '&:hover': {
            borderColor: 'primary.main',
            ...themeStyles.card?.['&:hover'],
          },
        }}
      >
        Clear Search
      </Button>
    </Box>
  );
};

export default EmptySearchState;
